import React, { useEffect, useState } from 'react';
import { CheckCircle2, Loader2, MailX } from 'lucide-react';
import { api } from '../services/api';

const UnsubscribePage = ({ id, email }) => {
  const [state, setState] = useState('working');
  const [address, setAddress] = useState(email || '');
  const [message, setMessage] = useState('');

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      if (!id && !email) {
        setState('missing');
        setMessage('This unsubscribe link is missing a recipient. Open the link from the email you received.');
        return;
      }
      try {
        const result = await api.unsubscribe({ id, email });
        if (cancelled) return;
        setAddress(result?.email || email || '');
        setState('done');
      } catch (error) {
        if (cancelled) return;
        setState('error');
        setMessage(error?.payload?.error || error?.message || 'We could not complete that unsubscribe.');
      }
    };
    run();
    return () => {
      cancelled = true;
    };
  }, [id, email]);

  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-12">
      <div className="w-full max-w-lg rounded-2xl bg-white p-8 shadow-sm">
        {state === 'working' && (
          <div className="flex items-center gap-3 text-gray-600">
            <Loader2 className="animate-spin" size={22} />
            <p>Unsubscribing…</p>
          </div>
        )}
        {state === 'done' && (
          <div>
            <CheckCircle2 className="mb-4 text-green-600" size={32} />
            <h1 className="text-2xl font-semibold text-gray-900">You are unsubscribed</h1>
            <p className="mt-3 text-gray-600">
              {address ? <strong>{address}</strong> : 'This address'} will not receive any more marketing emails.
            </p>
          </div>
        )}
        {state !== 'working' && state !== 'done' && (
          <div>
            <MailX className="mb-4 text-amber-600" size={32} />
            <h1 className="text-2xl font-semibold text-gray-900">Unsubscribe link not recognized</h1>
            <p className="mt-3 text-gray-600">{message}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;
